<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>搜索</title>
    <desc>Created with Sketch.</desc>
    <g id="配件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="1-1-配件"
        transform="translate(-703.000000, -322.000000)"
        fill="currentColor"
        fill-rule="nonzero"
      >
        <g id="编组-28" transform="translate(269.000000, 310.000000)">
          <g id="编组-27">
            <path
              d="M442.357128,23.3980397 C441.115713,23.8269656 439.781053,23.7468255 438.598609,23.1732443 C437.418181,22.5991591 436.531096,21.5986682 436.101162,20.356749 C435.921225,19.8360905 435.829492,19.295775 435.829492,18.7489071 C435.829492,16.6546806 437.159616,14.7867615 439.14094,14.1002786 C440.382356,13.6703447 441.717015,13.7514928 442.898452,14.325074 C444.080896,14.8991592 444.966973,15.8996501 445.396907,17.1405613 C445.576844,17.6632359 445.669585,18.2035514 445.669585,18.7484031 C445.669585,20.8441418 444.338957,22.7110528 442.357128,23.3980397 Z M449.765801,26.4514271 L446.13228,22.8179062 C447.007269,21.6576392 447.498694,20.2282224 447.498694,18.7489071 C447.498694,18.018574 447.377728,17.27312 447.124707,16.5427869 C445.906981,13.0206556 442.064793,11.1547527 438.542662,12.3724786 C435.75288,13.3376878 433.999375,15.9525728 433.999375,18.7489071 C433.999375,19.4812564 434.120341,20.2236862 434.373362,20.9560355 C435.592096,24.4786707 439.434283,26.3445737 442.955407,25.1258397 C443.642393,24.8879396 444.266881,24.5487303 444.817781,24.1334132 L448.451302,27.765926 C448.745653,28.0612851 449.205325,28.07943 449.478002,27.8072561 L449.806627,27.4786314 C450.079809,27.2059535 450.06116,26.7462821 449.765801,26.4514271 Z"
              id="搜索"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Search'
});
</script>
